import type { ComponentType } from 'react';
import {
  CONTEXTUAL_COURSE_PATTERN,
  CONTEXTUAL_SERIES_PATTERN,
  CONTEXTUAL_VIDEO_PATTERN,
} from '@/shared/lib/chrome/route-classes';
import { CourseSidebarContent } from './CourseSidebarContent';
import { SeriesSidebarContent } from './SeriesSidebarContent';
import { VideoSidebarContent } from './VideoSidebarContent';
import type { ContextualSidebarComponentProps, ContextualSidebarEntry } from './types';

/**
 * Registry of route-pattern → contextual-sidebar-component mappings.
 *
 * Add a new contextual sidebar by:
 *  1. Creating `<XSidebarContent>` in this folder (mirror CourseSidebarContent)
 *  2. Appending an entry below
 *
 * Order matters only if patterns overlap — first match wins. Today's patterns
 * are mutually exclusive.
 */
const CONTEXTUAL_SIDEBARS: readonly ContextualSidebarEntry[] = [
  {
    match: CONTEXTUAL_COURSE_PATTERN,
    component: CourseSidebarContent,
  },
  {
    match: CONTEXTUAL_SERIES_PATTERN,
    component: SeriesSidebarContent,
  },
  {
    match: CONTEXTUAL_VIDEO_PATTERN,
    component: VideoSidebarContent,
  },
];

export interface ResolvedContextualSidebar {
  Component: ComponentType<ContextualSidebarComponentProps>;
  paramValue: string;
}

export function resolveContextualSidebar(pathname: string): ResolvedContextualSidebar | null {
  for (const entry of CONTEXTUAL_SIDEBARS) {
    const result = entry.match.exec(pathname);
    if (result) {
      const paramValue = result[entry.paramIndex ?? 1];
      if (paramValue !== undefined) {
        return { Component: entry.component, paramValue };
      }
    }
  }
  return null;
}
